import cn from 'classnames';
import { MuiDivider, MuiStack } from '../../../../../modules/material';
import CircledIcon from '../../library/CircledIcon';
import { useTheme } from '@mui/material/styles';
import { StackProps as MuiStackProps } from '@mui/material';
import { UniqueIdentifier } from '../../../../../types';
import { PricingIconTypes } from '../../../types/enums';
import InfoWidgetItemDefault from './InfoWidgetItemDefault';
import InfoWidgetItemWithPaper from './InfoWidgetItemWithPaper';
import { PricingIcons } from '../../../helpers/icons/icons';

export interface WidgetItem {
  id: UniqueIdentifier;
  title: string;
  description?: string;
  iconId: keyof typeof PricingIconTypes;
}

export enum InfoWidgetVariants {
  default = 'default',
  withPaper = 'withPaper',
}

export interface InfoWidgetProps extends MuiStackProps {
  list: WidgetItem[];
  variant?: keyof typeof InfoWidgetVariants;
}

export default function InfoWidgetList(props: InfoWidgetProps) {
  const { list, variant = 'default', ...stackProps } = props;
  const theme = useTheme();
  const divider = variant === 'default' && <MuiDivider flexItem />;

  return (
    <MuiStack
      spacing={2}
      direction="column"
      divider={divider}
      {...stackProps}
      className={cn(stackProps.className, 'informa-payment-info-widget')}
    >
      {list.map((item) => {
        const Icon = PricingIcons[item.iconId];

        if (variant === InfoWidgetVariants.withPaper) {
          return (
            <InfoWidgetItemWithPaper
              key={item.id}
              title={item.title}
              description={item.description}
              icon={
                <CircledIcon
                  backgroundRGBColor={theme.palette.neutral.RGB0}
                  opacity={1}
                  size="small"
                >
                  <Icon sx={{ color: theme.palette.brandPrimary.mainCustom }} />
                </CircledIcon>
              }
            />
          );
        }

        return (
          <InfoWidgetItemDefault
            key={item.id}
            title={item.title}
            description={item.description}
            icon={
              <CircledIcon
                backgroundRGBColor={theme.palette.brandPrimary.lightRGB}
                opacity={1}
                size="small"
              >
                <Icon sx={{ color: theme.palette.brandSecondary.mainCustom }} />
              </CircledIcon>
            }
          />
        );
      })}
    </MuiStack>
  );
}
